export default {
  TYPE_QUERY_EQUAL: 0,
  TYPE_QUERY_DISTINCT: 1,
  TYPE_QUERY_CONTAINS: 2,
  TYPE_QUERY_GREATER_THAN: 3,
  TYPE_QUERY_LESS_THAN: 4,
  TYPE_QUERY_SET_OF_IDS: 10,
};
